import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import product1 from '../images/image1.png';
import product2 from '../images/image3.png';
import product3 from '../images/image2.png';
import { Link } from 'react-router-dom';
import { Header, Segment } from 'semantic-ui-react';

const CarouselComponent = ({ currentIndex }) => {
  return (
    <Segment raised>        
      <Header as='h1' textAlign='center' content='Our Products' />

      <Carousel selectedItem={currentIndex} showArrows infiniteLoop emulateTouch transitionTime={750} showStatus={false} showThumbs={false} autoPlay={false} interval={5000}>
        <div>
          <div className="title-header" style={styles.header1}><Link to='glucanosom'>Glucanosom&trade;</Link><div className='sub-header'>THE YEAST GLUCAN</div></div>
          <img alt="" src={product1} />
        </div>
        
        <div>
          <div className="title-header" style={styles.header2}><Link to='dermaglucan'>DermaGlucan&trade;</Link><div className='sub-header'>THE NEW BETA-GLUCAN FOR SKIN CARE</div></div>
          <div className="title-header" style={styles.header3}><Link to='leviall'>LeviAll&trade;</Link><div className='sub-header'>NATURAL YEAST COMPOUND<br className='unless-mobile' /><br/>SAFEGUARDS SKIN HEALTH</div></div>
          <img alt="" src={product2} />
        </div>

        <div>
          <div className="title-header" style={styles.header4}><Link to='flaxpower'>FLAX-POWER&trade;</Link><div className='sub-header'>A NUTRITIONAL HEAVYWEIGHT</div></div>
          <div className="title-header" style={styles.header5}>&nbsp;<br className='if-mobile' /><br className='if-mobile' /><div className='sub-header'>by  ABAC Advanced Bioproducts - Switzerland</div></div>
          <img alt="" src={product3} />
        </div>
      </Carousel>
    </Segment>
  );
}

const styles = {
  header1: {
    top: '15%',
    left: '7%',
  },
  header2: {
    top: '12%',
    left: '3%',
  },
  header3: {
    top: '46%',
    left: '10%',
  },
  header4: {
    top: '16%',
    left: '5%',
  },
  header5: {
    top: '23%',
    left: '-2%',
  },
}

export default CarouselComponent;


// WEBPACK FOOTER //
// ./src/components/Carousel.js